

<template>
    <div class="twoPageWarp">
        <div class="page2TitleWarp">
          <div class="title fAb">BioTrack Capital</div>
          <div class="desc fOM" v-html="aboutInfo.one.desc">
          </div>
        </div>
      <div class="artList">
        <div class="artItem" v-for="v in aboutInfo.two" :key="v.id">
          <img class="artItemImage" src="../../assets/image/art_list_log.png" alt="">
          <div class="artItemText fOR" v-html="v.desc">
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  computed:{
    aboutInfo(){
      return this.$store.getters.homeData.aboutInfo
    }
  }
}
</script>
<style scoped lang="scss">
  .twoPageWarp{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    //overflow: hidden;
    .artList{
      overflow: hidden;
      overflow-y: scroll;
      margin-left: -4rem;
      margin-top: -1rem;
      /* 隐藏滚动条 */
      -ms-overflow-style: none; /* IE 和 Edge */
      scrollbar-width: none; /* Firefox */

      display: flex;
      align-items: stretch;
      flex-wrap: wrap;
      .artItem{
        width: calc(50% - 4rem);
        margin-left: 4rem;
        //float: left;
        //max-height: 12vh;
        color: #fff;
        font-size: .9rem;
        background: linear-gradient(146deg, #3578C1 0%, rgba(43,106,185,0) 80%);
        border-radius: 100rem;
        margin-top: 1.2rem;
        padding: 1.2rem 1.2rem 1.2rem 3.5rem;
        box-sizing: border-box;
        position: relative;
        min-height: 6rem;
        .artItemImage{
          width: 5rem;
          position: absolute;
          left: -2.2rem;
          top: 0;
          z-index: 10;
        }
        .artItemText{
          height: 100%;
          //overflow-y: hidden;
          word-break: keep-all;
          hyphens:none;
        }
      }
    }
    .page2TitleWarp{
      color: #fff;
      width: calc(100% + 2rem);
      margin-left: -2rem;
      .title{
        font-size: 1.8rem;
      }
      .desc{
        font-size: 1rem;
        margin-top: 10px;
        line-height: 1.6rem;
        @media (max-height: 700px) {
          font-size: .8rem;
        }
      }
    }
  }
</style>
